import { render, staticRenderFns } from "./Raportointi.vue?vue&type=template&id=018c51f6&scoped=true"
import script from "./Raportointi.vue?vue&type=script&lang=js"
export * from "./Raportointi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c51f6",
  null
  
)

export default component.exports